import { ContentStatus } from '@addmile/backend-client';

import JourneyConfirmModal from '../JourneyConfirmModal/JourneyConfirmModal';

interface TakeOfflineModalProps {
  journeyTitle: string;
  // The status the online journey would move to; undefined keeps the dialog closed.
  status?: ContentStatus;
  onConfirm: () => void;
  onClose: () => void;
}

const TakeOfflineModal = ({ journeyTitle, status, onConfirm, onClose }: TakeOfflineModalProps) => {
  const toDraft = status === ContentStatus.Draft;

  return (
    <JourneyConfirmModal
      isOpen={!!status}
      title={toDraft ? 'Move the journey back to draft?' : 'Make the journey offline?'}
      confirmLabel={toDraft ? 'Set Draft' : 'Set Offline'}
      onConfirm={onConfirm}
      onClose={onClose}
    >
      Users who started <b>{journeyTitle || 'this journey'}</b> won’t see it until it’s back online.
      Their progress is kept.
    </JourneyConfirmModal>
  );
};

export default TakeOfflineModal;
